import { memo, PropsWithChildren, useMemo } from 'react';
import { Button } from 'src/modules/common/components/Button/Button';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { ResetIcon } from 'src/modules/common/icons/ResetIcon';

type Props = PropsWithChildren<{
    title?: string;
    description?: string;
    handleClose?: () => void;
    handleReset?: () => void;
}>

export const ModalHeader = memo(({ title, description, children, handleClose, handleReset }: Props) => {
    const translatedDescription = useMemo(() => (description ? <I18n messageId={description}/> : null), [description]);

    return (
        <div className="vss-modal-header">
            <div className="vss-modal-header__actions">
                {handleReset && (
                    <Button kind="ghost" iconOnly={true} onClick={handleReset}>
                        <div className="vss-modal-header__icon">
                            <ResetIcon/>
                        </div>
                    </Button>
                )}

                {handleClose && (
                    <Button kind="ghost" iconOnly={true} onClick={handleClose}>
                        <div className="vss-modal-header__icon">
                            <CrossIcon/>
                        </div>
                    </Button>
                )}
            </div>

            {title ? (<p className="vss-modal-header__title"><I18n messageId={title}/></p>) : null}

            <p className="vss-modal-header__description">{children || translatedDescription}</p>
        </div>
    );
});
